import React from "react";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

export default function DateRangePicker({
  onDateRangePick,
  defaultRange,
  size,
}) {
  return (
    <RangePicker
      showTime={{ format: "HH" }}
      format="YYYY-MM-DD HH"
      onOk={onDateRangePick}
      defaultValue={defaultRange}
      size={size}
    />
  );
}
